
import i18n from "@/i18n";
import { TopicType } from "@/types/assistant";

/**
 * Get a welcome message based on session topic and current language
 */
export const getWelcomeMessage = (topic: TopicType, language: string = i18n.language): string => {
  // Default fallback messages in English
  const defaultMessages = {
    guide: "Hello! I'm your AI Guide. How can I help you navigate our platform today?",
    performance: "Welcome to the Performance Analysis! I can help you understand your trading metrics and improve your results.",
    trading_strategy: "Hi there! I'm your Strategy Expert. Let me help you develop or optimize your trading strategies.",
    advisor: "Welcome! I'm your Financial Advisor assistant. How can I help with your investment planning today?"
  };
  
  try {
    // Try to get translated welcome message from i18n
    const translationKey = `ai_assistant.welcome_messages.${topic}`;
    const translated = i18n.t(translationKey);
    
    // If the translation key exists and is not the same as the key itself
    if (translated && translated !== translationKey) {
      return translated;
    }
    
    // Fallback to default messages
    return defaultMessages[topic];
  } catch (error) {
    console.error("Error getting welcome message:", error);
    return defaultMessages[topic];
  }
};
